<template>
    <div class="user-group">
        <Row>
            <Col :xs="24" :sm="12">
            <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                <FormItem>
                    <Input v-model="formItem.key" clearable placeholder="输入关键词查找..."></Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="renderTable('formItem')">查找</Button>
                </FormItem>
            </Form>
            </Col>
            <Col :xs="24" :sm="12">
            <Button @click="showModel()" type="success" class="f-r">添加</Button>
            </Col>
        </Row>
        <Table border :columns="list" ref="userList" :data="tablelist" :loading="dataloading"></Table>
        <Modal v-model="showStatus" :title=title @on-ok="updateGroup('groupValidate')" :loading="loading">
            <Form :model="groupInfo" ref="groupValidate" :rules="groupValidate" action="javascript:void(0)">
                <FormItem label="分组名称" prop="person">
                    <Input v-model="groupInfo.person" placeholder="输入姓名..." style="width: 500px"></Input>
                </FormItem>
                <FormItem label="积分" prop="points">
                    <Input v-model="groupInfo.points" placeholder="输入积分..." style="width: 500px"></Input>
                </FormItem>
                <FormItem label="折扣" prop="discount">
                    <Input v-model="groupInfo.discount" placeholder="输入折扣..." style="width: 500px"></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "user-group",
        data() {
            return {
                tablelist: [],
                pages: {
                    page: 1,
                    size: 10,
                    total: 0
                },
                id: 0,
                dataloading: false,
                loading: false,
                showStatus: false,
                list: [
                    {
                        title: 'Id',
                        key: 'uuid',
                        minWidth: 270,
                        fixed: 'left'
                    },
                    {
                        title: '姓名',
                        width: 120,
                        key: 'person',
                    },
                    {
                        title: '电话',
                        width: 150,
                        key: 'phone',
                    },
                    {
                        title: '省',
                        width: 100,
                        key: 'area_name1',
                    },
                    {
                        title: '市',
                        width: 100,
                        key: 'area_name2',
                    },
                    {
                        title: '区',
                        width: 100,
                        key: 'area_name3',
                    },
                    {
                        title: '地址',
                        width: 200,
                        key: 'address',
                    },
                    {
                        title: '操作',
                        key: 'action',
                        fixed: 'right',
                        width: 100,
                        align: 'left',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    style: {
                                        marginRight: '8px'
                                    },
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    on: {
                                        click: () => {
                                            this.showEdit(params.row.id)
                                        }
                                    }
                                }, '修改')
                            ]);
                        }
                    }
                ],
                groupInfo: [],
                title:''

            }
        },
        created: function () {
            // 取数据
            this.getTableList();
        },
        methods: {
            getTableList: function () {
                this.$api.usergroup.list().then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.tablelist = res.result.list;
                        this.pages.total = res.result.total;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            },
            // 翻页
            changePage() {
                this.pages.page = this.$refs['listPage'].currentPage;
                this.renderTable(1);
            },
            // 展开添加
            showModel() {
                this.title = "添加";
                this.showStatus = !this.showStatus;
            },
            showEdit(id) {
                this.address_id = id;
                this.$api.user.addressdetail({id: id}).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.addressInfo = res.result;
                    }
                })
                this.showStatus = !this.showStatus;
            },
            // 筛选
            renderTable: function (name) {
                if (name != 1) {
                    this.pages.page = 1;
                }
                var ps = {
                    "page": this.pages.page,
                    "size": this.pages.size,
                    "id": this.id,
                };
                this.$api.user.addresslist(ps).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.tablelist = res.result.list;
                        this.pages.total = res.result.total;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            },
        }
    }
</script>

<style scoped>

</style>